import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/InvoiceDownload';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const InvoiceDownload = ({ t }) => (
  <Container>
    <Col md={12}>
        <h3 className="page-title">REPORTS - Invoice  </h3>
      </Col>
    <Row>
      <HorizontalForm />
    </Row>

   
  </Container>
);

InvoiceDownload.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(InvoiceDownload);
